/* tslint:disable */

declare var Object: any;
export interface SFAttendanceStatusInterface {
  "id"?: number;
}

export class SFAttendanceStatus implements SFAttendanceStatusInterface {
  "id": number;
  constructor(data?: SFAttendanceStatusInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `SFAttendanceStatus`.
   */
  public static getModelName() {
    return "SFAttendanceStatus";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of SFAttendanceStatus for dynamic purposes.
  **/
  public static factory(data: SFAttendanceStatusInterface): SFAttendanceStatus{
    return new SFAttendanceStatus(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'SFAttendanceStatus',
      plural: 'SFAttendanceStatuses',
      path: 'SFAttendanceStatuses',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/SFAttendanceStatus.ts